/// <amd-module name="Artifacts/Package/types/Index" />

export * from "Artifacts/Package/types/ICommandControlProps";
